import UtilsSchema from "@repoflow/schema/utils";
import TypesSchema from "@common/schema/types";

import {
  orgId, viewId, title, description, query, tables, params, tags,
  createdAt, updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...TypesSchema,
  {
    id: "/Public/View",
    type: "object",
    properties: {
      orgId, viewId, title, description, query, tables, params, tags,
      createdAt, updatedAt,
    },
  },
  {
    id: "/Public/View/Create",
    type: "object",
    properties: { viewId, title, tags },
    required: ["viewId", "title"],
  },
  {
    // No `viewId` — the range key, so an input for it would read as a rename
    // and would write a second row.
    //
    // No `tables` either, and that one is the important absence: it is derived
    // from `query` by the model, and accepting it here would let a caller
    // declare a list that does not match what their SQL reads — which is
    // precisely the check the anonymous rows route depends on.
    id: "/Public/View/Update",
    type: "object",
    properties: { title, description, query, params, tags },
    required: ["title"],
  },
];
